(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["in-stock-collection-display"] && !Shopify.designMode) return;
  try {
    
  /*
   * Logos saved on a dark, solid background show as a dark box on the card's tile. Check each image's corners once
   * it has loaded: when they're solid and dark, blend the image with the tile (lighten), which keeps the logo and
   * lets the tile show through the box. Transparent and light images are left as they are.
   */
  (() => {
    const DARK = 70;

    /** @param {HTMLImageElement} image */
    const check = (image) => {
      if (image.dataset.iscChecked) return;
      image.dataset.iscChecked = 'true';
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return;
        context.drawImage(image, 0, 0, 32, 32);
        const corners = [
          [1, 1],
          [30, 1],
          [1, 30],
          [30, 30],
        ].map(([x, y]) => context.getImageData(x, y, 1, 1).data);
        const solidAndDark = corners.every((pixel) => pixel[3] > 250 && (pixel[0] + pixel[1] + pixel[2]) / 3 < DARK);
        if (solidAndDark) image.classList.add('instock-collections__image--flatten');
      } catch (error) {
        // The image couldn't be read (no cross-origin access): leave it as it is
      }
    };

    const run = () => {
      document.querySelectorAll('img.instock-collections__image').forEach((element) => {
        const image = /** @type {HTMLImageElement} */ (element);
        if (image.complete && image.naturalWidth) check(image);
        else image.addEventListener('load', () => check(image), { once: true });
      });
    };

    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
